import React, { useEffect } from "react";
import Header, {
  NoHeaderScroll,
  BackHeaderLeft,
} from "../../components/navigation/header";
import axios from "../../services/axios";
import { useNavigate } from "react-router";
import useAuth from "../../hooks/useAuth";

function HeaderLeft() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/home");
  };

  return <BackHeaderLeft onClick={handleBack} />;
}

export default function Premium() {
  const navigate = useNavigate();
  const { user, getUser } = useAuth();

  useEffect(() => {
    if (user?.isPremium) {
      navigate("/home");
    }
  }, [user]);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");
    if (sessionId) {
      axios
        .get(`payment/session-status?session_id=${sessionId}`)
        .then((res) => {
          const { status, customer_email } = res.data;

          if (status === "open") {
            navigate("/premium");
            return;
          }

          getUser({
            email: customer_email,
          })
            .then((data) => {
              console.log(data);
            })
            .finally(() => {
              navigate("/home");
            });
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, []);

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={HeaderLeft} HeaderCenter={() => {}} />
      <NoHeaderScroll className="ps-5 pe-5">
        <div>callback</div>
      </NoHeaderScroll>
    </div>
  );
}
